import EventEmitter from 'events';

const chatEventEmitter = new EventEmitter();

export default chatEventEmitter;
